import axios from 'axios';
import API_BASE_URL from '../Config/config.jsx';

/**
 * Tracks student activity for various features
 * @param {Object} data - Tracking data
 * @param {string} data.feature - Feature name (MockInterview, TSG, TechExplorer)
 * @param {string} [data.technology] - Technology/Subtopic
 * @param {string} [data.topic] - Main topic
 * @param {number} [data.score] - Score percentage
 * @param {number} [data.total_questions] - Total questions in session
 * @param {string} [data.status] - Status (active, completed, viewed)
 * @param {string} [data.last_action] - Brief description of last action
 * @param {string} [data.tech_stack] - Tech stack for TechExplorer
 * @param {string} [data.module_name] - Module for TechExplorer
 * @param {number} [data.progress] - Progress percentage for TechExplorer
 */
export const trackFeatureUsage = async (data) => {
  try {
    const userJson = localStorage.getItem('user');
    if (!userJson) return;
    
    const user = JSON.parse(userJson);
    const userId = user.userId || user.id || user.user_id;
    const collegeName = user.college_name || localStorage.getItem('college_name');
    
    if (!userId || !collegeName) return;

    await axios.post(`${API_BASE_URL}/college/analytics/track`, {
      ...data,
      user_id: userId,
      college_name: collegeName
    });
  } catch (error) {
    console.error('Failed to track feature usage:', error);
  }
};
